import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import { RemoveButton } from 'LegacyWeployDesignLanguage/buttons';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Theme from 'LegacyWeployDesignLanguage/Theme';
import styled from 'styled-components';
import Color from 'color';

const INFO = 'INFO';
const ERROR = 'ERROR';
const SUCCESS = 'SUCCESS';

const styles = () => ({
  [SUCCESS]: {
    backgroundColor: Theme.colors.weployAqua,
  },
  [ERROR]: {
    backgroundColor: Theme.colors.error,
  },
  [INFO]: {
    backgroundColor: Color(Theme.colors.weployAqua).lighten(0.5).string(),
    color: Theme.colors.black,
  },
});

const ToastMessage = styled.span`
  font-size: ${props => props.theme.typography.normal};
`;

const Toast = (props) => {
  const {
    classes,
    type,
    message,
    onDismiss,
    open,
    autoHideDuration,
  } = props;

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onDismiss}
    >
      <SnackbarContent
        className={classNames(classes[type])}
        message={
          <ToastMessage>
            {message}
          </ToastMessage>}
        action={<RemoveButton onClick={onDismiss} />}
      />
    </Snackbar>
  );
};

Toast.propTypes = {
  classes: PropTypes.object.isRequired,
  type: PropTypes.oneOf([SUCCESS, ERROR, INFO]),
  autoHideDuration: PropTypes.number,
  message: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

Toast.defaultProps = {
  type: INFO,
  autoHideDuration: null,
  open: false,
  message: '',
};

Toast.INFO = INFO;
Toast.ERROR = ERROR;
Toast.SUCCESS = SUCCESS;

export default withStyles(styles)(Toast);
